import { Emitter, Event } from "../../../../../features/event-emitter"
import { Data } from "../../../../../features/ui"
import { Measure, MeasureType, useMeasureBuilders } from "../../../../common"
import { useVehicleActions } from "../../../actions/vehicleActions"
import { useVehicleBuilders } from "../../../builders/vehicleBuilders"

export const useActions = () => {
    const { buildVehicle } = useVehicleBuilders()
    const { buildMeasure } = useMeasureBuilders()

    const { saveVehicle } = useVehicleActions()

    const submitVehicle = async (
        vehicleData: Data,
        weightUnits: number,
        maxLoadWeightUnits: number,
        weightUnitTypeId: string,
        loadMeasuresData: Data[] = [],
        createMode: boolean
    ) => {
        Emitter.emit(Event.DB_SUBMIT)
        
        const weight = buildMeasure({
            type: MeasureType.WEIGHT,
            units: weightUnits,
            unitTypeId: weightUnitTypeId
        })
        const maxLoadWeight = buildMeasure({
            type: MeasureType.WEIGHT,
            units: maxLoadWeightUnits,
            unitTypeId: weightUnitTypeId
        })
        const vehicle = buildVehicle({
            ...vehicleData,
            weight,
            maxLoadWeight,
            loadMeasures: loadMeasuresData as Measure[]
        })

        await saveVehicle(vehicle)
        Emitter.emit(Event.DB_SUBMIT_DONE, createMode)
    }
    
    return {
        submitVehicle
    }
}
